export default "__VITE_ASSET__COGmCS9a__"